import "core-js/modules/es6.array.is-array";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import "core-js/modules/es6.array.reduce";
export var setFromArray = function setFromArray(array) {
  return array.reduce(function (acc, value) {
    acc.add(value);
    return acc;
  }, new Set());
};
export var toArray = function toArray(value) {
  return Array.isArray(value) ? value : [value];
};